export const $ = selector => {
    return document.querySelector(selector)
}
